import { MUT_ALTERS } from "./mut-columns.js";

export const topicsTable = `
CREATE TABLE IF NOT EXISTS topics (
  id          TEXT PRIMARY KEY,
  name        TEXT NOT NULL,
  parent_id   TEXT,
  color       TEXT,
  icon        TEXT,
  owner_id    TEXT,
  mut         INTEGER NOT NULL DEFAULT 0,
  server_acked_mut INTEGER NOT NULL DEFAULT 0,
  created_at  TEXT NOT NULL,
  updated_at  TEXT NOT NULL,
  deleted_at  TEXT
);
`.trim();

export const topicsIndexes = [
  "CREATE INDEX IF NOT EXISTS idx_topics_parent ON topics(parent_id);",
];

export const topicsAlters = [
  "ALTER TABLE topics ADD COLUMN icon TEXT;",
  ...MUT_ALTERS("topics", { google: false }),
];
